import { Button } from '@core/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const ShareEventWidget = ({ url }: { url: string }) => {
    const { t } = useTranslation();

    const [copyButtonTitle, setCopyButtonTitle] = useState('');
    const copyWebinarURL = () => {
        setCopyButtonTitle(t('Share.CopiedLink'));
        navigator.clipboard.writeText(`${url}`);
    };

    return (
        <div className="w-full">
            <div className="flex">
                <input
                    data-testid="share-event-input"
                    onFocus={(e) => e.target.select()}
                    value={`${url}`}
                    readOnly
                    className="flex-1 border-y-2 border-l-2 border-primary rounded-button outline-hidden -me-8 py-2 ps-2 pe-10 truncate"
                />
                <Button variant="primary" onClick={copyWebinarURL} data-testid="share-event-button">
                    {t('Share.Button.CopyLink')}
                </Button>
            </div>
            <div className="text-primary pt-2">{copyButtonTitle}</div>
        </div>
    );
};
